import {
  Button,
  Divider,
  Grid,
  MenuItem,
  MenuList,
  TextField,
  Typography,
} from '@material-ui/core';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';

import { ICalendarQuickSelectorOptions } from '~/src/dash/utils/calendar';
import { usePublicaTranslation } from '~/src/dash/publicaUI';

interface IStateUpdater {
  value: number;
  setter: React.Dispatch<React.SetStateAction<number>>;
}

interface IProps {
  startDate: moment.Moment;
  endDate: moment.Moment;
  calStartDate: moment.Moment;
  calEndDate: moment.Moment;
  isCompareCalendar: boolean;
  rangeSelected: string;
  calendarQuickSelectorOptions: ICalendarQuickSelectorOptions[];
  calendarQuickSelectorCustomOptions: ICalendarQuickSelectorOptions[];
  handleCalendarDateChange: (start: moment.Moment, end: moment.Moment, isCustom: boolean) => void;
  handleFocusedInputChange: (focusedInput: any) => void;
  handleDateRangeChange: (
    start: moment.Moment,
    end: moment.Moment,
    isCompareCalendar: boolean,
  ) => void;
  handleRangeSelected: (
    rangeSelected: string,
    isCompareCalendar: boolean,
    applied?: boolean,
  ) => void;
}

export function CalendarQuickSelector(props: IProps) {
  const {
    startDate,
    endDate,
    calStartDate,
    calEndDate,
    isCompareCalendar,
    rangeSelected,
    calendarQuickSelectorOptions,
    calendarQuickSelectorCustomOptions,
    handleCalendarDateChange,
    handleFocusedInputChange,
    handleDateRangeChange,
    handleRangeSelected,
  } = props;
  const [field1, setField1] = useState(0);
  const [field2, setField2] = useState(0);
  const [field3, setField3] = useState(0);
  const [field4, setField4] = useState(0);
  const [tempRangeSelected, setTempRangeSelected] = useState(rangeSelected);

  const { t } = usePublicaTranslation();

  useEffect(() => {
    setTempRangeSelected(rangeSelected);
  }, [rangeSelected]);

  const customInputs: { [key: string]: IStateUpdater } = {
    ' Days Up To Today': { value: field1, setter: setField1 },
    ' Days Up To Yesterday': { value: field2, setter: setField2 },
    ' Days Ago, Same Period': { value: field1, setter: setField1 },
    ' Weeks Ago, Same Period': { value: field3, setter: setField3 },
    ' Months Ago, Same Period': { value: field4, setter: setField4 },
  };

  return (
    <MenuList style={{ width: 180, height: 300 }}>
      <Grid container direction='column' justify='flex-start' style={{ height: '100%' }}>
        <Grid item>
          {/* Render each of the selectors */}
          {calendarQuickSelectorOptions.map((ele: ICalendarQuickSelectorOptions) => {
            const { title, date1, date2, tKey } = ele;
            return (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setTempRangeSelected(title);
                  handleCalendarDateChange(date1(e), date2(e), false);
                }}
                style={{ paddingTop: 2, paddingBottom: 2, fontSize: 12 }}
              >
                {tKey ? t(tKey) : title}
              </MenuItem>
            );
          })}
          <Divider variant='middle' />

          {/* Render each of the numerical selectors */}
          {calendarQuickSelectorCustomOptions.map((ele: ICalendarQuickSelectorOptions) => {
            const { title, date1, date2, tKey } = ele;
            return (
              <MenuItem
                onClick={(e) => e.stopPropagation()}
                style={{ paddingTop: 2, paddingBottom: 2 }}
              >
                <Grid container>
                  <Grid item xs={2} alignContent='center'>
                    <TextField
                      id='standard-number'
                      size='small'
                      value={customInputs[`${title}`].value}
                      type='number'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (parseInt(e.currentTarget.value, 10) < 0) {
                          return;
                        }
                        setTempRangeSelected(`${e.currentTarget.value} ${title}`);
                        handleRangeSelected(`${e.currentTarget.value} ${title}`, isCompareCalendar);
                        customInputs[`${title}`].setter(parseInt(e.currentTarget.value, 10));
                        handleCalendarDateChange(
                          date1(e.currentTarget.value),
                          date2(e.currentTarget.value),
                          false,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: 10 },
                      }}
                    ></TextField>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography style={{ marginLeft: 10, marginTop: 5, fontSize: 10 }}>
                      {tKey ? t(tKey) : title}
                    </Typography>
                  </Grid>
                </Grid>
              </MenuItem>
            );
          })}
          <Divider variant='middle' style={{ marginTop: 4, marginBottom: 0 }} />
        </Grid>
        <Grid item>
          <Grid container justify='flex-start' style={{ paddingLeft: 12 }}>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleRangeSelected(tempRangeSelected, isCompareCalendar, true);
                handleFocusedInputChange('apply');
                handleDateRangeChange(calStartDate, calEndDate, isCompareCalendar);
              }}
              style={{ fontSize: '0.85rem', color: '#4952FF' }}
            >
              Apply
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleRangeSelected(rangeSelected, isCompareCalendar, false);
                handleFocusedInputChange(null);
                handleCalendarDateChange(startDate, endDate, false);
              }}
              style={{ fontSize: '0.85rem', color: '#4952FF' }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </MenuList>
  );
}
